import {useContext} from "react";
import {Pressable, StyleSheet, View} from "react-native";
import {Colors} from "../colors";
import PropTypes from "prop-types";
import AppConfigContext from "../../../contexts/AppConfigContext";

export function CardView(props: any){
    const color = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    const lStyle = StyleSheet.create({
        flat: {
            width: props.width ?? "auto",
            height: props.height ?? "auto",
            backgroundColor: props.backColor ?? color.get("lowConBackground"),
            boxShadow: props.shadow ?? "none",
            borderRadius: props.radius ?? 12,
            paddingHorizontal: props.ph ?? 12,
            paddingVertical: props.pv ?? 12,
            borderWidth: props.borderWidth ?? 0,
            borderColor: props.borderColor ?? 0,
            marginVertical: props.mv ?? 8,
            marginHorizontal: props.mh ?? 8
        },
        elevated: {
            width: props.width ?? "auto",
            height: props.height ?? "auto",
            backgroundColor: props.backColor ?? color.get("highConBackground"),
            boxShadow: props.shadow ?? ("0px 2px 6px ".concat(color.get("shadow") as string)),
            borderRadius: props.radius ?? 8,
            paddingHorizontal: props.ph ?? 20,
            paddingVertical: props.pv ?? 10,
            borderWidth: props.borderWidth ?? 0,
            borderColor: props.borderColor ?? 0,
            marginVertical: props.mv ?? 8,
            marginHorizontal: props.mh ?? 8
        },
        sphere: {
            width: props.width ?? "auto",
            height: props.height ?? "auto",
            backgroundColor: props.backColor ?? color.get("highConBackground"),
            boxShadow: props.shadow ?? ("0px 2px 6px ".concat(color.get("shadow") as string)),
            borderRadius: props.radius ?? 100,
            paddingHorizontal: props.ph ?? 15,
            paddingVertical: props.pv ?? 15,
            borderWidth: props.borderWidth ?? 0,
            borderColor: props.borderColor ?? 0,
            marginVertical: props.mv ?? 8,
            marginHorizontal: props.mh ?? 8
        },
        card: {
            marginVertical: 8,
            overflow: "hidden"
        }
    });
    // @ts-ignore
    const inside = <View {...props} style={[props.style, lStyle.card].concat(lStyle[props.scheme])}>
        {props.children}
    </View>;

    return props.onPress == null ? inside : <Pressable onPress={props.onPress}>{inside}</Pressable>
}

CardView.propTypes = {
    radius: PropTypes.number,
    ph: PropTypes.number,
    pv: PropTypes.number,
    mh: PropTypes.number,
    mv: PropTypes.number,
    mb: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    borderWidth: PropTypes.number,
    borderColor: PropTypes.string,
    backColor: PropTypes.string,
    scheme: PropTypes.oneOf(["flat", "elevated", "sphere"]),
    style: PropTypes.any,
    onPress: PropTypes.func,
    children: PropTypes.any
}